import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';

const stopIcons = {
  PICKUP: 'load-pickup',
  DROPOFF: 'load-dropoff',
};

const StopIcon = React.memo(({ stop_type }) => (
  <Icon glyph={stopIcons[stop_type]} size="1.6rem" color="grey500" />
));

StopIcon.propTypes = {
  stop_type: PropTypes.oneOf(['DROPOFF', 'PICKUP']),
};

export default StopIcon;
